import styled from 'styled-components';
import theme from '../../../styles/theme/theme';

export const CustomSwitch = styled.div`
	.switch-color {
		&.is-first {
			.MuiSwitch-colorSecondary.Mui-checked {
				color: ${(props) => props.theme.palette.switchColors.first};
			}
			.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
				background-color: ${(props) => props.theme.palette.switchColors.first};
			}
		}

		&.is-second {
			.MuiSwitch-colorSecondary.Mui-checked {
				color: ${(props) => props.theme.palette.switchColors.second};
			}
			.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
				background-color: ${(props) => props.theme.palette.switchColors.second};
			}
		}

		&.is-third {
			.MuiSwitch-colorSecondary.Mui-checked {
				color: ${(props) => props.theme.palette.switchColors.third};
			}
			.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
				background-color: ${(props) => props.theme.palette.switchColors.third};
			}
		}

		&.is-fourth {
			.MuiSwitch-colorSecondary.Mui-checked {
				color: ${(props) => props.theme.palette.switchColors.fourth};
			}
			.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
				background-color: ${(props) => props.theme.palette.switchColors.fourth};
			}
		}

		&.is-fifth {
			.MuiSwitch-colorSecondary.Mui-checked {
				color: ${(props) => props.theme.palette.switchColors.fifth};
			}
			.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
				background-color: ${(props) => props.theme.palette.switchColors.fifth};
			}
		}

		&.is-sixth {
			.MuiSwitch-colorSecondary.Mui-checked {
				color: ${(props) => props.theme.palette.switchColors.sixth};
			}
			.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
				background-color: ${(props) => props.theme.palette.switchColors.sixth};
			}
		}
	}
`;

export const switchGraphDataNetzentgelte = [
	{
		name: 'Strombezug historisch',
		dataKey: 'load_profile',
		colorName: 'first',
		color: theme.palette.switchColors.first,
		unit: 'MWh',
	},
	{
		name: 'Strombezug aktuell',
		dataKey: 'new_load_profile',
		colorName: 'second',
		color: theme.palette.switchColors.second,
		unit: 'MWh',
	},
	{
		name: 'scalebloc',
		dataKey: 'battery_power',
		colorName: 'third',
		color: theme.palette.switchColors.third,
		unit: 'MWh',
	},
	{
		name: 'Zielleistung',
		dataKey: 'target_load',
		colorName: 'fourth',
		color: theme.palette.switchColors.fourth,
		unit: 'MWh',
	},
];

export const switchGraphDataEigenverbrauch = [
	{
		name: 'Strombezug historisch',
		dataKey: 'load_profile [MWh]',
		colorName: 'first',
		color: theme.palette.switchColors.first,
		unit: 'MWh',
	},
	{
		name: 'Strombezug aktuell',
		dataKey: 'new_load_profile [MWh]',
		colorName: 'second',
		color: theme.palette.switchColors.second,
		unit: 'MWh',
	},
	{
		name: 'Stromvermarktung',
		dataKey: 'sold_renewable_power [MWh]',
		colorName: 'fifth',
		color: theme.palette.switchColors.fifth,
		unit: 'MWh',
	},
	{
		name: 'PV Anlage',
		dataKey: 'used_renewable_power [MWh]',
		colorName: 'sixth',
		color: theme.palette.switchColors.sixth,
		unit: 'MWh',
	},
	{
		name: 'scalebloc',
		dataKey: 'stored_renewable_power [MWh]',
		colorName: 'third',
		color: theme.palette.switchColors.third,
		unit: 'MWh',
	},
];
